import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';
const {
  tooltip_container,
  tooltip_trigger,
  tooltip_content,
  visible,
  position_top,
  position_bottom,
  position_left,
  position_right
} = styles;

const Tooltip = ({ children, content, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClass = {
    top: position_top,
    bottom: position_bottom,
    left: position_left,
    right: position_right
  }[position];

  return (
    <div
      className={tooltip_container}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      <div className={tooltip_trigger} tabIndex={0} role="button" aria-label="More information">
        {children}
      </div>
      {isVisible && (
        <div
          className={classNames(tooltip_content, positionClass, { [visible]: isVisible })}
          role="tooltip"
        >
          {content}
        </div>
      )}
    </div>
  );
};

Tooltip.propTypes = {
  /**
   * The trigger element (typically an info icon)
   */
  children: PropTypes.node.isRequired,

  /**
   * The content to display in the tooltip
   */
  content: PropTypes.node.isRequired,

  /**
   * Position of the tooltip relative to the trigger (top, bottom, left, right)
   */
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

export default Tooltip;
